const Phases = {
    HISTORICAL: 'Historical',
    PREDICTED: 'Predicted',
    HUMAN_REVIEWED: 'Human-reviewed',
}

export default Phases
